<template>
  <section id="lectures">
    <div class="lectures__block">
      <img src="@/assets/images/speaker.png" class="lectures__image" />
      <div class="lectures__content">
        <div class="lectures__type intersect--fly-in">
          <img src="@/assets/icons/lecture.svg" class="lectures__icon" />
          <h2 class="lectures__title online-tag">Predavanja</h2>
          <p class="lectures__description">
            Pridruži se zanimljivim predavanjima stručnjaka o aktualnim Dev, Design, Marketing & Tech temama.
          </p>
        </div>
        <div class="lectures__type intersect--fly-in">
          <img src="@/assets/icons/workshop.svg" class="lectures__icon" />
          <h2 class="lectures__title live-tag">Radionice</h2>
          <p class="lectures__description">
            Praktičan rad na radionicama koje vode stručnjaci za najnovije tehnologije obogatit će te novim vještinama.
          </p>
        </div>
        <div class="lectures__type intersect--fly-in">
          <img src="@/assets/icons/panel.svg" class="lectures__icon" />
          <h2 class="lectures__title online-tag">Panel rasprave</h2>
          <p class="lectures__description">
            Kroz moderirane rasprave saznaj kakva su mišljenja profesionalaca o zanimljivim temama iz IT svijeta.
          </p>
        </div>
      </div>
    </div>
    <div class="lectures__block">
      <img src="@/assets/images/panelist.png" class="lectures__image" />
      <div class="lectures__content">
        <div class="lectures__type intersect--fly-in intersect--fly-in--right">
          <img src="@/assets/icons/fly-talks.svg" class="lectures__icon" />
          <h2 class="lectures__title live-tag">Fly talks</h2>
          <p class="lectures__description">
            Tražiš posao? Porazgovaraj s poslodavcima oči u oči i saznaj jesi li upravo ti ono što im treba.
          </p>
        </div>
        <div class="lectures__type intersect--fly-in intersect--fly-in--right">
          <img src="@/assets/icons/rewards.svg" class="lectures__icon" />
          <h2 class="lectures__title">Nagrade</h2>
          <p class="lectures__description">
            Iskaži se u ispunjavanju zadataka koji će ti omogućiti uživanje u vrijednim nagradama.
          </p>
        </div>
      </div>
    </div>
    <div class="look-and-feel-wrapper">
      <h2 class="look-and-feel-title">Kako će DUMP Days izgledati 2021.?</h2>
      <p class="look-and-feel-description">
        Ove godine donosimo konferenciju u hibridnom obliku! Nudimo mnoštvo sadržaja na FESB-u, ali i za sve koji odluče
        sudjelovati iza svojih ekrana.
      </p>
      <div class="look-and-feel">
        <div class="lectures__type intersect--fly-in">
          <img src="@/assets/icons/live.svg" class="lectures__icon" />
          <h2 class="lectures__title">Uživo</h2>
          <p class="lectures__description">
            Uz prethodnu prijavu na aplikaciji te poštivajući epidemiološke mjere, uživo sudjeluj na radionicama, druži
            se s predstavnicima IT tvrtki i razgovaraj s budućim poslodavcima.
          </p>
        </div>
        <div class="lectures__type intersect--fly-in intersect--fly-in--right">
          <img src="@/assets/icons/online.svg" class="lectures__icon" />
          <h2 class="lectures__title">Online</h2>
          <p class="lectures__description">
            Na našem YouTube kanalu, u stvarnom vremenu, prati sva predavanja i panel rasprave u kojima imaš priliku
            poslušati iskustva brojnih stručnjaka iz svijeta IT-ja.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Lectures',
};
</script>

<style scoped>
#lectures {
  padding: 40px 24px 0 24px;

  margin: auto;
  max-width: 1440px;
}

.lectures__block {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 60px;
}

.lectures__block:last-of-type {
  margin-bottom: 0;
}

.lectures__image {
  width: 250px;
}

.lectures__type {
  margin-top: 48px;
  position: relative;
}

.lectures__title {
  color: #fff;
  font-size: 24px;
  line-height: 36px;
  font-weight: 800;
  margin-bottom: 8px;
}

.lectures__description {
  color: #ffffffcc;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.lectures__content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.lectures__icon {
  width: 40px;
  height: 40px;
  position: absolute;
  left: -24px;
  top: -8px;
  z-index: -1;
}

.look-and-feel-wrapper {
  max-width: 375px;
  margin: auto;
  padding-left: 24px;
  padding-right: 24px;
}

.look-and-feel-title {
  font-weight: 800;
  font-size: 32px;
  line-height: 38px;
  color: #ffffff;
  margin-bottom: 16px;
  max-width: 280px;
}

.look-and-feel-description {
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 48px;
}

.look-and-feel .lectures__type {
  margin: auto;
}

.look-and-feel .lectures__type:not(:last-child) {
  margin-bottom: 48px;
}

@media screen and (min-width: 350px) {
  .lectures__image {
    width: 327px;
    height: 392px;
  }

  .lectures__type {
    width: 300px;
  }
}

@media screen and (min-width: 1180px) {
  #lectures {
    padding: 110px 205px 0 205px;
  }

  .look-and-feel-wrapper {
    max-width: unset;
  }

  .look-and-feel-title {
    font-size: 48px;
    line-height: 58px;
    max-width: 570px;
  }

  .look-and-feel-description {
    max-width: 505px;
    margin-bottom: 106px;
  }

  .look-and-feel {
    display: flex;
  }

  .look-and-feel .lectures__type {
    margin: unset;
  }

  .look-and-feel .lectures__type:not(:last-child) {
    margin-bottom: 0;
  }

  .look-and-feel .lectures__type:first-child {
    margin-right: auto;
  }

  .look-and-feel .lectures__type:last-child {
    margin-left: auto;
  }

  .lectures__block {
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: stretch;
    margin-bottom: 136px;
  }

  .lectures__block:nth-of-type(2) {
    flex-direction: row;
  }

  .lectures__image {
    width: 400px;
    height: auto;
  }

  .lecture__content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .lectures__block:nth-of-type(2) .lectures__content {
    justify-content: center;
  }

  .lectures__type {
    margin-top: 0;
  }

  .lectures__block:nth-of-type(2) .lectures__type:first-of-type {
    margin-bottom: 98px;
  }

  .lectures__title {
    font-size: 28px;
    line-height: 38px;
    margin-bottom: 16px;
  }

  .lectures__description {
    line-height: 24px;
  }

  .lectures__icon {
    width: 64px;
    height: 64px;
    left: -38px;
    top: -28px;
  }
}

@media screen and (min-width: 1280px) {
  .lectures__image {
    width: 505px;
    height: 605px;
  }

  .lectures__title {
    font-size: 32px;
    line-height: 38px;
  }
}
</style>
